<template>
  <q-select
    v-model="selectedSymbol"
    :options="optionSymbols"
    use-input
    hide-selected
    clearable
    dense
    behavior="box"
    fill-input
    input-debounce="0"
    option-value="symbol"
    option-label="symbol"
    emit-value
    stack-label
    map-options
    @filter="filterSymbols"
    label="Symbol"
    :filled="filled"
    style="width: 125px"
  >
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey"> No results </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script setup>
import { ref, watch } from "vue";
import { useStore } from "vuex";
const emit = defineEmits(["emitededSymbol"]);
const props = defineProps({
  allStocks: {
    type: Array,
  },
  filled: {
    type: Boolean,
    default: () => false,
  },
  activeSymbol: {
    type: String,
    default: () => "",
  },
});

const optionSymbols = ref([]);
const selectedSymbol = ref(props.activeSymbol);

const filterSymbols = (val, update) => {
  update(() => {
    const searchQuery = val.toLowerCase();
    // let mutualFunds = [13, 14, 15];
    // optionSymbols.value = allStocks.value.filter((stock) => {
    //   let symbol = stock.symbol.toLowerCase().includes(searchQuery);
    //   let sector = !mutualFunds.includes(stock.sector);
    //   return symbol & sector;
    // });
    const mutualFunds = new Set([14, 15]);
    optionSymbols.value = props.allStocks.filter(
      ({ symbol, sector }) =>
        symbol.toLowerCase().includes(searchQuery) && !mutualFunds.has(sector)
    );
  });
};

// watch(selectedSymbol, (newVal) => {
//   newVal === null ? emit("emitededSymbol", "") : emit("emitededSymbol", newVal);
// });

watch(selectedSymbol, (newVal) => emit("emitededSymbol", newVal ?? ""));
</script>
